import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Receipt } from "lucide-react";

export default function FraisDialog({ open, onOpenChange, form, setForm, submitting, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="frais-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Receipt className="w-5 h-5 text-amber-600" />
            Ajouter un frais de tournée
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-2">
          <div className="space-y-1">
            <Label>Type</Label>
            <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
              <SelectTrigger data-testid="frais-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="essence">⛽ Essence</SelectItem>
                <SelectItem value="adblue">🔵 AdBlue</SelectItem>
                <SelectItem value="peage">🛣️ Péage</SelectItem>
                <SelectItem value="parking">🅿️ Parking</SelectItem>
                <SelectItem value="lavage">🧽 Lavage</SelectItem>
                <SelectItem value="autre">📌 Autre</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1">
            <Label>Montant (€)</Label>
            <Input type="number" step="0.01" min="0.01" value={form.montant}
              onChange={(e) => setForm({ ...form, montant: e.target.value })}
              placeholder="100.00" required data-testid="frais-montant-input" />
          </div>
          <div className="space-y-1">
            <Label>Note (optionnel)</Label>
            <Input value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })}
              placeholder="Station Total, Péage Bruxelles-Mons…" data-testid="frais-note-input" />
          </div>
          <p className="text-xs text-slate-500 bg-slate-50 p-2 rounded border">
            💡 Ce frais sera automatiquement enregistré dans la page <b>Charges</b> (catégorie Transport).
          </p>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button type="submit" className="bg-amber-600 hover:bg-amber-700" disabled={submitting} data-testid="frais-submit-btn">
              {submitting ? "Enregistrement..." : "Enregistrer"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
